import { useCustomer } from 'public/components/online_ordering/CustomerContextCommon'
import React, { useState } from 'react'
import { t } from 'src/translations'
import { CreditCardRow } from 'public/components/default_template/online_ordering/checkout/payment/SavedCreditCards'
import { CreditIcon } from '@toasttab/buffet-pui-icons'

const SavedPaymentMethods = () => {
  const { customer } = useCustomer()
  const [errorMsg, setErrorMsg] = useState('')

  return (
    <div
      className='accountSection savedCards'
      data-testid='SavedPaymentMethods'
      tabIndex={0}
    >
      <div className='sectionHeader'>
        <h2 className='sectionTitle'>{t('payment-methods.payment-methods')}</h2>
      </div>
      {customer?.creditCards?.length ? (
        <>
          <div className='listItemsContainer' role='listitem'>
            {customer?.creditCards.map((card) => (
              <CreditCardRow
                key={card.guid}
                {...card}
                onError={setErrorMsg}
                hideInputs={true}
              />
            ))}
          </div>
          {errorMsg && <div className='submitError'>{errorMsg}</div>}
          <div className='savedCardsDisclaimer'>
            {t('payment-methods.card-details-disclaimer')}
          </div>
        </>
      ) : (
        <div className='emptySection'>
          <div className='iconContainer'>
            <CreditIcon accessibility='decorative' />
          </div>
          <div className='header'>
            {t('payment-methods.no-saved-payment-methods')}
          </div>
          <div className='description'>
            {t('payment-methods.payment-methods-will-appear-here')}
          </div>
        </div>
      )}
    </div>
  )
}

export default SavedPaymentMethods
